import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { RevealOnScrollDirective } from '../../reveal-on-scroll.directive';
import { FaqSectionService } from './faq-section.service';

@Component({
  selector: 'app-faq-section',
  standalone: true,
  imports: [NgFor, NgIf, RevealOnScrollDirective],
  templateUrl: './faq-section.component.html',
  styleUrl: './faq-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FaqSectionComponent {
  get sections() {
    return this.faqService.sections;
  }
  activeFaqId: string | null = null;

  constructor(private readonly faqService: FaqSectionService) {}

  toggleFaq(id: string): void {
    this.activeFaqId = this.activeFaqId === id ? null : id;
  }
}
